export enum EventResponseStatus {
  NO_RESPONSE,
  FIRST_RESPONSE,
  SUBSCRIBED,
  DISCONNECTED,
}
